import { z } from "zod";

import { PORT_MAX, PORT_MIN } from "../constants";
import { machineSchema } from "../machine";

const trackConfigurationSchema = z.object({}).passthrough();
const machineSettingsSchema = z.object({}).passthrough();

export const x5MachineRequestSchema = z.object({
	alias: z.string().optional(),
	description: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
	assetId: z.string().or(z.number()).optional(),
	plcVersion: z.string().nullish(),
	tracks: z.array(trackConfigurationSchema).optional(),
	physicalMachineSettings: machineSettingsSchema.nullish(),
	iotEdgeDeviceId: z.string().nullish(),
});

export const x5MachineSchema = machineSchema.extend({
	iotHubName: z.string().optional(),
	isDoubleTampPrinter: z.boolean().optional(),
});

export type X5Machine = z.infer<typeof x5MachineSchema>;
export type X5MachineRequest = z.infer<typeof x5MachineRequestSchema>;
